import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { FantasyHistoryStore, FantasyHistoryState } from './fantasy-history.store';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FantasyHistory } from './models/fantasy-history.model';
import { GameStatus } from '../fantasy/models/game-status.enum';
import moment, { Moment } from 'moment/moment';

@Injectable({ providedIn: 'root' })
export class FantasyHistoryQuery extends QueryEntity<FantasyHistoryState> {
  constructor(protected store: FantasyHistoryStore) {
    super(store);
  }

  /**
   * Gets a list of selected players for fantasy
   */
  selectAllHistory() {
    return this.selectAll();
  }

  /**
   * Gets a list of selected players for games before a given date
   * @param date the end date
   * @param gameStatuses Only the game statuses supplied will show
   */
  selectHistoryBeforeDate(date: Date | Moment, gameStatuses: GameStatus[] = []): Observable<FantasyHistory[]> {
    return this.selectAll().pipe(
      map((items) => {
        return items
          .filter((item) => moment.utc(item.EndDate).isBefore(date))
          .filter((item) => {
            if (!gameStatuses || gameStatuses.length === 0) {
              return true;
            }

            if (gameStatuses.includes(item.Status)) {
              return true;
            } else {
              return false;
            }
          });
      })
    );
  }
}
